export function contentBlockPlugin(markdown) {
  // Stole this from
  // https://github.com/posva/markdown-it-custom-block/blob/master/index.js
  const contentBlockRE = /<([A-Z][a-zA-Z]*)((?:(?!\/>)[^\n])*)\/>/;
  markdown.block.ruler.before(
    "fence",
    "contentBlock",
    (state, startLine, endLine, silent) => {
      const startPos = state.bMarks[startLine] + state.tShift[startLine];
      const maxPos = state.eMarks[startLine];
      const block = state.src.slice(startPos, maxPos);

      // XXX wtf
      // (not sure what this does but copied it to be sure)
      if (startLine !== 0) {
        let prevLineStartPos =
          state.bMarks[startLine - 1] + state.tShift[startLine - 1];
        let prevLineMaxPos = state.eMarks[startLine - 1];
        if (prevLineMaxPos > prevLineStartPos) return false;
      }

      if (block[0] !== "<") {
        return false;
      }

      const match = contentBlockRE.exec(block);
      if (!match) {
        return false;
      }

      if (!silent) {
        const [markup, contentBlockName, attrs] = match;

        const token = state.push("contentBlock", "div", 0);
        token.markup = markup;
        token.attrs = [
          ["name", contentBlockName],
          ["props", parseProps(attrs)],
        ];
        token.block = true;
        token.map = [startLine, startLine + 1];
        state.line = startLine + 1;
      }

      return true;
    }
  );
}

function parseProps(attrs) {
  const props = {};

  let m;
  // eslint-disable-next-line no-cond-assign
  while ((m = attrs.match(/^\s*([a-zA-Z]+)="([^"]*)"/))) {
    props[m[1]] = m[2];
    attrs = attrs.slice(m[0].length);
  }

  return props;
}
